import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Conversation } from 'src/app/interfaces/conversation';
import { Message } from 'src/app/interfaces/message';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent {
  imageSrc!: string;
  @Input() isModalOpen!: boolean;
  @Input() message = {} as Message;
  @Input() selectedConversation!: Conversation;
  @Output() close = new EventEmitter<void>();
  isLoading = true;
  isLoadingDownloadButton = false;

  constructor(private api: ApiService) {}

  async ngOnInit() {
    this.isLoading = true;
    const res = await this.api.getImageMessage(this.message.id, this.message.conversationId);
    if (res && res.base64) {
      this.imageSrc = `data:image/jpeg;base64,${res.base64}`;
      this.isLoading = false;
    }
  }

  closeModal() {

    this.isModalOpen = false;
    this.close.emit();
  }

  downloadImage() {
    this.isLoadingDownloadButton = true;
    const link = document.createElement('a');
    link.href = this.imageSrc;
    link.download = this.message.data.filename || 'image.jpg';
    link.click();
    this.isLoadingDownloadButton = false;
  }
}
